import { actions } from "modules/WordPairs/actions";
import { wpmTexts } from "../../helpers/wpmTextsProvider";
import { shuffle } from ".././/../helpers/arrayFunctions"

export const NAME = 'WPM_TEST'
export const types = {
  //GET_SUBSCRIPTION_REQUEST: `${NAME}/GET_SUBSCRIPTION_REQUEST`,
}

export const initialState = {
  //POINTS_PER_CLICK: 2.75,
  text: wpmTexts[1][0].text,
  textName: wpmTexts[1][0].name,
  questions: (() => {
    let questions = wpmTexts[1][0].questions
    questions.map( item => {
      item.variants = shuffle(item.variants)
    })
    return questions
  })(),
  wordsInText: wpmTexts[1][0].text.split(" ").length,
  textLevel: 1,
  currentQuestionIndex: 0,
  textSelectorIsVisible: false,
  currentRound: 0,
  points: 0,
  timeLeft: 60,
  countDown: 3,
  wrongAnswers: 0,
  exersizeState: "startScrean",
  readingFinished: false
}



export function reducer(state = initialState, action) {
  switch (action.type) {
    case "PREEXERSIZE":
      return {
        ...state,
        exersizeState: "preexersize"
      };
    case "INCREMENT_COUNTDOWN":
      return {
        ...state,
        countDown: state.countDown - 1,
      };
    case "INCREMENT":
      return {
        ...state,
        timeLeft: state.timeLeft - 1
      }
    case "SET_INCREMENT_COUNT_DOWN":
      return {
        ...state,
        countDown: action.newCountDown
      }
    case "START_GAME":
      return {
        ...state,
        exersizeState: "gameStarted",
        startTime: action.startTime
      }
    case "GAME_OVER": {
      return {
        ...state,
        exersizeState: 'gameOver'
      }
    }
    case "SHOW_GAME_OVER_SCREAN": {
      return {
        ...state,
        exersizeState: 'scoreScrean'
      }
    }
    case "NEW_ROUND": {
      return {
        ...state,
        currentRound: action.currentRound,
      }
    }
    case "SET_TEXT":
      return {
        ...state,
        text: action.text,
        textName: action.textName,
        questions: action.questions,
        wordsInText: action.wordsInText,
        textLevel: action.textLevel
      };
    case "SHOW_TXT_SELECTOR":
      return {
        ...state,
        textSelectorIsVisible: true
      };
    case "HIDE_TXT_SELECTOR":
      return {
        ...state,
        textSelectorIsVisible: false
      };
    case "FINISH_READING":
      return {
        ...state,
        readingFinished: true
      }
    case "SHOW_QUESTIONS":
      return {
        ...state,
        endTime: action.endTime,
        exersizeState: 'questions'
      }
    case "ANSWER_CLICK":
      return {
        ...state,
        showAnswerRight: action.data.showAnswerRight,
        showAnswerWrong: action.data.showAnswerWrong,
        points: action.data.points,
        answerIndex: action.data.answerIndex
      }
    case "QUESTION_SWITCHED": 
      return {
        ...state,
        nextQuestion: false,
        answerIndex: false
      }
    case "SWITCH_QUESTION":
      if(action.exersizeState) {
        return {
          ...state,
          exersizeState: action.exersizeState
        }
      } else {
        return {
          ...state,
          nextQuestion: true,
          currentQuestionIndex: state.currentQuestionIndex + 1,
        }
      }      
    default:
      return { ...state }
  }
}
